module.exports = __webpack_public_path__ + "static/media/marker-unload.c18ceb40.png";